/**
 * Created by Kotkin on 18.07.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DataProvider from 'api/data-provider';
import apiDecorator from 'api/api-decorator';
import Modal, { Header, Content } from 'components/modal';

import CardInfoContainer from './card-info-container';

@apiDecorator
export default class CardInfoModal extends PureComponent {
  static propTypes = {
    opened: PropTypes.bool,
    onClose: PropTypes.func,
    userPhoto: PropTypes.any, // eslint-disable-line
    userName: PropTypes.string,
    userId: PropTypes.number
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.close = this.close.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
  }

  close() {
    this.props.onClose();
  }

  // Update counter views profile.
  updateCounter() {
    const { userId } = this.props;

    this.api.post('action/forum/actions-views-profile/view', {
      postData: { userId }
    });
  }

  render() {
    const { opened, userPhoto, userName, userId = {} } = this.props;

    return (
      <Modal
        className="cardInfoModal"
        renderModal={opened}
        onCloseRequired={this.close}
        size="medium"
        disableNotification
      >
        <Header closeButton>
          Визитная карточка
        </Header>
        <Content addPaddingB>
          <div>
            {this.updateCounter()}
            <DataProvider
              url="domik/users/users"
              query={{ 'user-id': this.props.userId }}
              renderer={this.showUserData}
              // renderMethod="list"
            >
              <CardInfoContainer
                userPhoto={userPhoto}
                userName={userName}
                userId={userId}
              />
            </DataProvider>
          </div>
        </Content>
      </Modal>
    );
  }
}
